// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"d1d5908e","234":"bbc1f478","797":"9ba9502b","925":"1af71ce1"}[chunkId] + ".chunk.js";
};